import { render, staticRenderFns } from "./NameAndLinkManager.vue?vue&type=template&id=68b7c744&scoped=true"
import script from "./NameAndLinkManager.vue?vue&type=script&lang=js"
export * from "./NameAndLinkManager.vue?vue&type=script&lang=js"
import style0 from "./NameAndLinkManager.vue?vue&type=style&index=0&id=68b7c744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b7c744",
  null
  
)

export default component.exports